@if (transportDetails) {
  <div class="planned-assignment-details-list-entry">
    <div class="information">
      <div class="row">
        <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
          [transport]="transportDetails">
        </app-transport-details>
      </div>
    </div>
  </div>
}
